import base64           from "base-64";
import utf8             from "utf8";
import { apiPost, apiGet, apiPost_demo } from "../utils/ajax";
import { providerChk }  from "../utils/provider.id.check";
import Provider         from '../model/Provider';
import Config           from '../model/Config';
import UmdOption        from "../model/UmdOption";
import GlobalVar from "../model/GlobalVar";
import { device } from "../utils/deviceCheck";

export const ajax = {
    //최초 토큰 얻기
    getToken: ()=>{
        return new Promise((resolve, reject) => {
            if(Config.system.alert_debug){
                alert(JSON.stringify("Request getToken"));
            }
            const url = Config.url.jsp.contextPath + Config.url.jsp.tokenPath
            apiPost(url, "").then(res => {
                UmdOption.callback.ajax.success.getToken(res);
                resolve(res)
            }, res => {
                UmdOption.callback.ajax.fail.getToken(res);
                reject(res)
            })
        })
    },
    //인증기관 목록
    getProviderList: ()=>{
        return new Promise((resolve, reject) => {
            if(Config.system.alert_debug){
                alert(JSON.stringify("Request getProviderList"));
            }
            var url = "";
            if(Config.url.jsp.providerListPath == "" ||  Config.url.jsp.providerListPath === undefined){
                url = Config.url.api.contextPath + Config.url.api.providerListPath;
            }else{
                url = Config.url.jsp.contextPath + Config.url.jsp.providerListPath;
            }
            apiGet(url).then(res => {
                UmdOption.callback.ajax.success.providerList(res);
                resolve(res)
            }, 
            res => {
                UmdOption.callback.ajax.fail.providerList(res);
                reject(res)
            });
        });
    },
    //인증요청
    requestAuth: ()=>{
        return new Promise((resolve, reject) => {
            if(Config.system.alert_debug){
                alert(JSON.stringify("Request AuthenticationRequest"));
            }

            // PASS isNotification - Y: PC(PUSH), N: MO(telcoTxid)
            if(device.isMobile()){
                Provider.providerOptionInfo.isNotification = "N"
            }else{
                Provider.providerOptionInfo.isNotification = "Y"
            }

            //------사용자명 인코딩-------
            if(!!Config.userInfo){
                if(!!Config.userInfo.base64){
                    if(Config.userInfo.base64){
                        const bytes = utf8.encode(Provider.userInfo.name);
                        const name = base64.encode(bytes);
                        Provider.userInfo.name = encodeURIComponent(name);
                    }
                }
            }else{
                const bytes = utf8.encode(Provider.userInfo.name);
                const name = base64.encode(bytes);
                Provider.userInfo.name = encodeURIComponent(name);
            }
            //---------------------------

            var paramsJson = Provider;

            // 본인인증(Nice) CompareCI False 그리고 삼성패스일 때 생년월일, 주민등록번호 제외
            if(Provider.compareCI == false && providerChk.isSamsung(Provider.providerId)){
                paramsJson.userInfo.birthday = "19700101";
                paramsJson.userInfo.ssn1 = "";
                paramsJson.userInfo.ssn2 = "";
            }

            var url = "";
            if(Config.url.jsp.requestPath == ""  ||  Config.url.jsp.requestPath === undefined){
                url = Config.url.api.contextPath + Config.url.api.requestPath;
            }else{
                url = Config.url.jsp.contextPath + Config.url.jsp.requestPath;
            }

            // App 호출 시 PUSH 형태로 지정 -> PC Code로 지정
            if(GlobalVar.appPush === true){
                Provider.deviceInfo.code = "PC"
            }
            var param = JSON.stringify(paramsJson);
            apiPost(url, param).then(res => {
                UmdOption.callback.ajax.success.authRequest(res);
                
                // App 호출 시 PUSH 형태로 지정 -> 원래 Code로 원복
                if(GlobalVar.appPush === true){
                    device.setDeviceCode()
                }
                resolve(res)
            },res => {
                UmdOption.callback.ajax.fail.authRequest(res);
                // App 호출 시 PUSH 형태로 지정 -> 원래 Code로 원복
                if(GlobalVar.appPush === true){
                    device.setDeviceCode()
                }
                reject(res)
            });
        })
    },
    //인증완료
    finishAuth: ()=>{
        return new Promise((resolve, reject) => {
            if(Config.system.alert_debug){
                alert(JSON.stringify("Request authenticationFinish"));
            }
            var url = "";
            if(Config.url.jsp.successPath == "" ||  Config.url.jsp.successPath === undefined){
                url = Config.url.api.contextPath + Config.url.api.successPath;
            }else{
                url = Config.url.jsp.contextPath + Config.url.jsp.successPath;
            }
            var param = JSON.stringify(Provider);
            apiPost(url, param).then(res => {
                UmdOption.callback.ajax.success.authComplete(res);
                var json = JSON.parse(res)
                if(json.signedData !== undefined){
                    json.signedData = encodeURIComponent(json.signedData);
                    res = JSON.stringify(json);
                }
                resolve(res)
            }, res => {
                UmdOption.callback.ajax.fail.authComplete(res);
                reject(res)
            });
        });
    },
    parseToken: (token)=>{
        return new Promise((resolve, reject) => {
            if(Config.system.alert_debug){
                alert(JSON.stringify("Request parseToken"));
            }
            const url = Config.url.jsp.contextPath + Config.url.jsp.parseTokenPath + "?token="+ token;
            apiGet(url).then(res => resolve(res), res => reject(res))
        });
    },
    parseSignData: (json)=>{
        return new Promise((resolve, reject) => {
            if(Config.system.alert_debug){
                alert(JSON.stringify("Request parseSignData"));
            }
            const url = Config.url.jsp.contextPath +  Config.url.jsp.parseSignPath;
            apiPost_demo(url, json).then(res => resolve(res), res => reject(res))
        });
    }
}
